export default __webpack_public_path__ + "static/media/b3.11543ee1.jpg";